module.exports = __webpack_public_path__ + "img/EXALT_INTEGRATED.873da863.svg";